import { render } from "./AppInputLabel.vue?vue&type=template&id=4c94cc33&scoped=true&lang=pug"
const script = {}

import "./AppInputLabel.vue?vue&type=style&index=0&id=4c94cc33&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c94cc33"]])

export default __exports__